import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {GtAbsenceService} from '@app/services/gt-absence.service';
import {GtAuthenticationService} from '@app/services/gt-authentication.service';
import * as momentNs from 'moment';
import {TranslateService} from '@ngx-translate/core';
import {MinuteDurationFormat} from '@app/shared/formatting.pipes';
import {absenceDuration} from '@app/models/status.constants';
import {StatusAbsentModel} from '@app/models/status-absent.model';

const moment = momentNs;

@Component({
  selector: 'gt-duration-settings',
  templateUrl: './duration-settings.component.html',
  styleUrls: ['./duration-settings.component.scss']
})
export class DurationSettingsComponent implements OnInit {
  @Input() login: string;
  @Input() orgname: string;

  @Input()
  public status: StatusAbsentModel;

  @Output()
  public backObservable = new EventEmitter<void>();

  public durationButtonGroupValue = '0';
  public durationAmountSelector = [1, 5, 10, 15, 20, 30, 40, 45, 50, 60, 70, 80, 90, 100];
  public durationEntitySelector = [{multiplier: 1, text: 'duration.minutes'}, {multiplier: 60, text: 'duration.hours'},
    {multiplier: 1440, text: 'duration.days'}];


  public durationAmountHolder = 15;
  public durationEntityHolder = 1;

  public defaultDurations = absenceDuration;

  constructor(private authenticationService: GtAuthenticationService,
              private absenceService: GtAbsenceService,
              private translate: TranslateService,
              private minuteDurationFormat: MinuteDurationFormat) {
  }

  ngOnInit() {
    this.login = this.login ? this.login : this.authenticationService.login;
    this.orgname = this.orgname ? this.orgname : this.authenticationService.oname;
    if (this.status.defaultDuration) {
      const minInADay = 60 * 24;
      const minInAnHour = 60;
      this.setButtonGroupValue();

      if (this.durationButtonGroupValue === '2') {

        // Split minutes into hour or days if it fits, else it will just display minutes by default.
        const numOfMinutes = +this.status.defaultDuration;
        if (numOfMinutes > 60) {
          if (numOfMinutes % minInADay === 0) {
            this.durationEntityHolder = minInADay;

          } else if (numOfMinutes % minInAnHour === 0) {
            this.durationEntityHolder = minInAnHour;
          }
        }
        this.durationAmountHolder = numOfMinutes / this.durationEntityHolder;
      }

    }
  }

  onBack() {
    this.backObservable.emit();
  }

  updateDurationDefaults() {
    switch (this.durationButtonGroupValue) {
      case '0':
        this.status.defaultDuration = null;
        break;
      case '1':
        const defaultDuration = this.defaultDurations.find(d => d.key === this.status.defaultDuration);
        if (defaultDuration) {
          this.status.defaultDuration = defaultDuration.key;
        } else {
          this.status.defaultDuration = this.defaultDurations[0].key;
        }
        break;
      case '2':
        this.status.defaultDuration = (this.durationAmountHolder * this.durationEntityHolder).toString();
        break;
    }
    this.sendDefaultsToBackend();
  }

  sendDefaultsToBackend() {
    this.absenceService.setAbsenceReasonForUser(this.orgname, this.login,
      this.status.createAbsenceReason())
      .subscribe(() => {
        }
      );
  }

  changeDefaultDuration(duration: string | number) {
    this.status.defaultDuration = duration.toString();
    this.sendDefaultsToBackend();
  }

  setButtonGroupValue() {
    this.defaultDurations.map(e => e.key).find(e => e === this.status.defaultDuration)
      ? this.durationButtonGroupValue = '1'
      : this.durationButtonGroupValue = '2';
  }

  getDurationToShow(): string {
    const absence = this.defaultDurations.find(e => e.key === this.status.defaultDuration);

    return absence ? this.translate.instant(absence.text) : this.minuteDurationFormat.transform(this.status.defaultDuration);
  }

}
